import type {
  FlightIngredient,
  FerryIngredient,
} from '@apps/main/modules/recipe/ingredients';

export enum TripType {
  Flight = 'flight',
  Ferry = 'ferry',
  Hotel = 'hotel',
  Car = 'car',
}
export type TripTypeOption = {
  tripType: TripType;
  title: string;
  description: string;
  saveMoney?: string;
  locationLabel?: string;
  destination?: string;
};

export interface CarStartPosition {
  name: string;
  placeId?: string;
}

export interface FlightTripSettings {
  outbound?: FlightIngredient;
  homebound?: FlightIngredient;
}

export interface FerryTripSettings {
  outbound?: FerryIngredient;
  homebound?: FerryIngredient;
}
